import React from "react";
import "./Common_title.css"

const Common_title = ({ text }) => {
  return (
    <div className="title_holder">
      <h1 className="title">{text}</h1>
    </div>
  );
};

export default Common_title;
